import { Environment } from '../models/environment';

if (!process.env.REACT_APP_API_URL) {
  throw new Error('MISSING_API_URL_VALUE');
}

export const getEnvValue = (
  envKey: string,
  mandatory = false,
  defaultValue: string = '',
): string => {
  const envValue = process.env[envKey];
  if (mandatory && !defaultValue && !envValue) {
    throw new Error(`ENV_MISSING_KEY_${envKey}`);
  }

  return envValue || defaultValue || '';
};

export const getEnvBooleanValue = (
  envKey: string,
  mandatory = false,
  defaultValue: boolean = false,
): boolean => {
  const envValue = process.env[envKey];
  if (mandatory && !defaultValue && !envValue) {
    throw new Error(`ENV_MISSING_KEY_${envKey}`);
  }

  return envValue ? envValue === 'true' : defaultValue || false;
};

const routingBasePathEnvParam = getEnvValue(
  'REACT_APP_ROUTING_BASE_PATH',
  true,
);
const routingBasePath =
  routingBasePathEnvParam !== '/' ? routingBasePathEnvParam : '';

const environmentValues: Environment = {
  /** Auth0 */
  routingBasePath,
  publicUrl: getEnvValue('PUBLIC_URL', true, '/'),
  auth0Domain: getEnvValue('REACT_APP_AUTH0_DOMAIN', true),
  auth0ClientId: getEnvValue('REACT_APP_AUTH0_CLIENT_ID', true),
  auth0Organization: getEnvValue('REACT_APP_AUTH0_ORGANIZATION', true),
  auth0Audience: getEnvValue('REACT_APP_AUTH0_AUDIENCE', true),
  disableAuth0: getEnvBooleanValue('REACT_APP_DISABLE_AUTH0', false, false),
  backendUrl: getEnvValue('REACT_APP_API_URL', true, 'http://localhost:3004'),
  useMockServer: getEnvBooleanValue('REACT_APP_USE_MOCK_SERVER', false, false),
  cdnUrl: getEnvValue('REACT_APP_CDN_URL'),
  googleMapsAPIKey: getEnvValue('REACT_APP_GOOGLE_MAPS_API_KEY', true),
  euVaultBaseUrl: getEnvValue('REACT_APP_SK_EU_VAULT_BASE_URL', true),
  usVaultBaseUrl: '',
  vaultImsTable: getEnvValue('REACT_APP_SK_SKYFLOW_IMS_PATIENT_TABLE', true, 'ims_patient'),
};

export const environment = {
  ...environmentValues,
};
